import { combineReducers } from "redux";
import authentication from 'services/redux/authentication/reducers';
import data from 'services/redux/data/reducers';
import cart from 'services/redux/cart/reducers';
import management from 'services/redux/management/reducers';

export default combineReducers({
	data,
	authentication,
	cart,
	management
})
